import Vue from 'vue';
import Vuex from 'vuex';


import actions from './actions';
import mutations from './mutations';
import getters from './getters';


import { initialState } from '../dataStructures';
import persistState from '../utils/persistState';

Vue.use(Vuex);

export default new Vuex.Store({
    state: initialState,
    mutations,
    actions,
    getters,
    plugins: [persistState]
});
